import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("kame_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Resolve stored image url into a displayable src
export const mediaUrl = (url) => {
  if (!url) return "/images/car-placeholder.svg";
  if (url.startsWith("http") || url.startsWith("/images")) return url;
  if (url.startsWith("/api")) return `${BACKEND_URL}${url}`;
  return url;
};

export const isAvailableNow = (car) => {
  if (!car) return true;
  const today = new Date().toISOString().split("T")[0];
  const f = (car.available_from || "").trim();
  const t = (car.available_to || "").trim();
  if (!f && !t) return true;
  if (f && t) return !(today >= f && today <= t);
  if (f && !t) return today < f;
  return today > t; // only "to" set → booked until t
};

export const effectivePricePerDay = (car, days) => {
  if (!car) return 0;
  let price = car.price_per_day;
  const tiers = (car.price_tiers || [])
    .filter((t) => t && t.min_days && t.price_per_day)
    .sort((a, b) => a.min_days - b.min_days);
  for (const t of tiers) if (days >= t.min_days) price = t.price_per_day;
  return price;
};

export const formatApiError = (detail) => {
  if (detail == null) return "Něco se pokazilo. Zkuste to prosím znovu.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
